import styled from '@emotion/styled';

export const ModalBackground = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
`;

export const Modal = styled.article`
  align-items: center;
  width: 312px;
  height: 190px;
  background-color: white;
  border-radius: 4px;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
  padding: 16px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f1f1f1;
  font-size: 16px;
  font-weight: bold;
  color: #696969;
  padding-bottom: 10px;
`;

export const ModalTitleText = styled.span``;

export const ModalClose = styled.div`
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

export const ModalBody = styled.div`
  width: 280px;
  height: 87px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CloseButton = styled.button`
  width: 132px;
  height: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  border: none;
  cursor: pointer;
  background-color: #697583;
`;

export const LoginButton = styled(CloseButton)`
  background-color: #284160;
`;
